import { DoctorEntry } from '../types'

type DoctorSeed = Omit<DoctorEntry, 'kind' | 'path' | 'published' | 'requiresReview' | 'review'>

export const DOCTOR_SEEDS: DoctorSeed[] = [
  {
    slug: 'joao-brunhara',
    name: 'João Brunhara',
    honorificPrefix: 'Dr.',
    crm: { number: '161642', uf: 'SP' },
    image: '/landings/dr-joao-brunhara.webp'
  },
  {
    slug: 'carlos-seraphim',
    name: 'Carlos Seraphim',
    honorificPrefix: 'Dr.',
    crm: { number: '156663', uf: 'SP' },
    image: '/landings/dr-carlos-seraphim.webp'
  }
]

export const MEDICAL_TEAM_PATH = '/equipe-medica'
